module.exports = __webpack_public_path__ + "img/1_025.fec1ac8f.jpg";